import { motion } from "framer-motion";

export default function Loader() {
  return (
    <div className="loader-wrapper">
      <div className="dots-spinner">
        <span className="dot-1"></span>
        <span className="dot-2"></span>
        <span className="dot-3"></span>
      </div>
    </div>
  );
}
